import { inject, provideZoneChangeDetection } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';
import { provideServiceWorker } from '@angular/service-worker';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import {
  provideHttpClient,
  withInterceptorsFromDi,
  withInterceptors,
} from '@angular/common/http';
import { provideStore } from '@ngrx/store';
import { ROOT_EFFECTS, ROOT_REDUCER } from './state/app.state';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { provideEffects } from '@ngrx/effects';
import {
  provideRouter,
  withHashLocation,
  withViewTransitions,
} from '@angular/router';
import { routes } from './app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { ApplicationConfig } from '@angular/core';
import { environment } from 'src/environments/environment';
import { provideApollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { createApollo } from './@graphql/modules/graphql.config';
import { provideNativeDateAdapter } from '@angular/material/core';
import { authInterceptor } from '@shared-interceptors';
import { provideGoogleMaps } from '@be-one-organization/be-one-elements';

export const appConfig: ApplicationConfig = {
  providers: [
    provideNativeDateAdapter(),
    provideTranslateService({
      fallbackLang: 'es',
      loader: provideTranslateHttpLoader({
        prefix: './assets/i18n/',
        suffix: '.json',
        enforceLoading: true,
        useHttpBackend: true,
      }),
    }),
    provideStore(ROOT_REDUCER),
    provideEffects(ROOT_EFFECTS),
    provideServiceWorker('ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerWhenStable:30000',
    }),
    provideStoreDevtools({
      maxAge: 25,
      logOnly: environment.production,
      connectInZone: true,
    }),
    provideRouter(routes, withHashLocation(), withViewTransitions()),
    { provide: APP_BASE_HREF, useValue: '/' },
    provideHttpClient(
      withInterceptors([authInterceptor]),
      withInterceptorsFromDi(),
    ),
    provideAnimations(),
    provideApollo(() => createApollo(inject(HttpLink))),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideGoogleMaps({
      apiKey: environment.googleMapsApiKey,
      language: 'en',
      region: 'CO',
      libraries: ['places'],
    }),
  ],
};
